<form [formGroup]="quoteRequestForm" class="cipx-form-container w-full">
  <cipx-scrollable-content #intakeFormScroll [removeOverflowOnMobile]="true">
    @if (
      selectedStateBond() !== null &&
      ![IntakeFormStep.PrincipalSelection, IntakeFormStep.BondLookup, IntakeFormStep.Confirmation].includes(
        currentStep()
      )
    ) {
      <div class="selected-bond mb-4">
        <div class="flex flex-row justify-between items-center w-full">
          <div class="flex flex-col">
            <span class="font-bold text-xl">
              {{ selectedBondLabel() }}
            </span>
          </div>
          <div class="flex flex-col">
            <button class="text-primary cursor-pointer" (click)="moveBack()">Change</button>
          </div>
        </div>
      </div>
    }
    <div class="step-content">
      @switch (currentStep()) {
        @case (IntakeFormStep.PrincipalSelection) {
          <cipx-quote-request-intake-form-principal-selection
            [quoteRequestForm]="quoteRequestForm"></cipx-quote-request-intake-form-principal-selection>
        }
        @case (IntakeFormStep.BondLookup) {
          <cipx-quote-request-intake-form-bond-lookup
            [quoteRequestForm]="quoteRequestForm"
            (complete)="onBondLookupComplete()"></cipx-quote-request-intake-form-bond-lookup>
        }
        @case (IntakeFormStep.RequestDetails) {
          <cipx-quote-request-intake-form-request-details
            [quoteRequestForm]="quoteRequestForm"></cipx-quote-request-intake-form-request-details>
        }
        @case (IntakeFormStep.AdditionalQuestions) {
          <cipx-quote-request-intake-form-additional-questions
            [quoteRequestForm]="quoteRequestForm"></cipx-quote-request-intake-form-additional-questions>
        }
        @case (IntakeFormStep.Notifications) {
          <cipx-quote-request-intake-form-notifications
            [quoteRequestForm]="quoteRequestForm"></cipx-quote-request-intake-form-notifications>
        }
        @case (IntakeFormStep.Confirmation) {
          <cipx-quote-request-intake-form-confirmation
            [quoteRequestForm]="quoteRequestForm"
            (closeRequested)="onConfirmationCloseRequested()"></cipx-quote-request-intake-form-confirmation>
        }
      }
    </div>
  </cipx-scrollable-content>

  <!-- Action Bar -->
  @if (currentStep() !== IntakeFormStep.Confirmation) {
    <cipx-action-bar [sticky]="true" [removeStickyOnMobile]="true" justify="end">
      @if (showCancelButton) {
        <cipx-cancel-button (buttonClick)="onCancel()">Cancel</cipx-cancel-button>
      }
      <cipx-primary-button
        [disabled]="!canProceed()"
        [icon]="'heroicons_outline:chevron-right'"
        (buttonClick)="handlePrimaryAction()">
        {{ getActionButtonText() }}
      </cipx-primary-button>
    </cipx-action-bar>
  }
</form>
